import React from "react";

const WidgetBoxSmall = ({ children, onClick, arialabel, id ,className }) => {

  return (
    <button
      id={id}
      role="region"
      aria-label={arialabel}
      className={`WidgetBoxSmall ${className}`}
      type="button"
      onClick={() => onClick()}
    >
      {children}
    </button>
  );
};

export default WidgetBoxSmall;
